import { axios } from '@Root/API'

export const getByName = userName => {
	return axios.get(`users/${userName}/name`)
}
